import { api } from "../../api/api";
import { IAuthContextUser } from "./auth.types";

export const AUTH_STORAGE_KEY = "auth_info";

export const setAuthStorage = (authInfo: IAuthContextUser) =>
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authInfo));

export const getAuthStorage = (): IAuthContextUser | null => {
  const authInfo = localStorage.getItem(AUTH_STORAGE_KEY);
  return authInfo ? JSON.parse(authInfo) : null;
};

export const clearAuthStorage = () => localStorage.removeItem(AUTH_STORAGE_KEY);

export const authStore = {
  save: (authInfo: IAuthContextUser) => {
    try {
      localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authInfo));
    } catch (error) {
      console.error("Failed to save auth:", error);
    }
  },
  load: (): IAuthContextUser | null => {
    try {
      const authInfo = localStorage.getItem(AUTH_STORAGE_KEY);
      return authInfo ? JSON.parse(authInfo) : null;
    } catch (error) {
      console.error("Failed to parse auth:", error);
      return null;
    }
  },
  clear: () => {
    try {
      localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch (error) {
      console.error("Failed to clear auth:", error);
    }
  },
};
